import React from "react";

function Branche({children}) {
    return <div className={'schema-branche'}>
        {children}
    </div>
}

export default Branche;